"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=worker-options.js.map